// @ts-nocheck
import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Button, Typography, Icon } from '@material-ui/core';
import { GridOverlay, GridToolbarContainer } from '@material-ui/data-grid';
import { useDialog, useIfMounted } from '../../../../common/hooks';
import { DataTable, EmptyState } from '../../../../common/components';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
}));

function TracerList(props) {
  const [selectedTracers, setSelectedTracers] = useState([]);
  const [t] = useTranslation();
  const { showDialog } = useDialog();
  const classes = useStyles();
  const ifMounted = useIfMounted();

  const { data, onClearTracers, actionsDisabled } = props;

  const getColumnDefs = () => [
    {
      field: 'traceService',
      headerName: t('tracer.traceService'),
      width: 250,
    },
    {
      field: 'traceKey',
      headerName: t('tracer.traceKey'),
      width: 300,
      flex: 1,
    },
  ];

  const getRowData = () =>
    data.map(tracer => ({
      ...tracer,
      id: tracer.traceService,
    }));

  const handleShowClearTracersDialog = () => {
    showDialog({
      title: t('common.important'),
      content: <Typography>{t('tracer.tracersClearConfirm')}</Typography>,
      onConfirm: async () => {
        const tracers = data.filter(tracer => selectedTracers.includes(tracer.traceService));
        await onClearTracers(tracers);
        ifMounted(() => setSelectedTracers([]));
      },
    });
  };

  const handleSelectTracers = params => {
    const { selectionModel } = params;
    setSelectedTracers(selectionModel);
  };

  const renderToolbar = () => (
    <GridToolbarContainer>
      <Button
        id="TracerList-clearTracers"
        variant="outlined"
        color="primary"
        startIcon={<Icon>delete</Icon>}
        onClick={handleShowClearTracersDialog}
        disabled={actionsDisabled || _.isEmpty(selectedTracers)}
      >
        {t('tracer.tracersClear')}
      </Button>
    </GridToolbarContainer>
  );

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('tracer.tracersEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="TracerList-container" className={classes.container}>
      <DataTable
        id="TracerList-table"
        components={{
          Toolbar: renderToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        selectionModel={selectedTracers}
        onSelectionModelChange={handleSelectTracers}
        pageSize={20}
        paginationMode="client"
        pagination
        checkboxSelection
      />
    </Box>
  );
}

TracerList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClearTracers: PropTypes.func.isRequired,
  actionsDisabled: PropTypes.bool.isRequired,
};

export default TracerList;
